import { render, staticRenderFns } from "./SendThisCruise.vue?vue&type=template&id=fa55d246&scoped=true"
import script from "./SendThisCruise.vue?vue&type=script&lang=js"
export * from "./SendThisCruise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa55d246",
  null
  
)

export default component.exports